import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Header from './component/Header';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '@fortawesome/fontawesome-free/css/all.min.css';
import HeroSection from './component/Hero';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import Foot from './component/Footer';
import AboutSection from './pages/AboutSection';
import Booking from './pages/Booking';
import OurFleet from './pages/OurFleet';
import Gallery from './pages/Gallery';
import Services from './pages/Services';
import OurNetwork from './pages/OurNetwork';
import ContactSection from './pages/ContactSection';
import Enquiry from './pages/Enquiry';
import CareersSection from './pages/CareersSection';
import TermsConditions from './pages/TermsConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Blog from './pages/Blog';
import Packages from './pages/Packages';
import Mumbaicabservice from './pages/Mumbai Cab Service';
import Mumbaitoshirdi from './pages/Mumbai to Shirdi Cab';
import MumbaiDarshancabs from './pages/Mumbai Darshan Cabs';
import Mumbaitovadodara from './pages/Mumbai to Vadodara Taxi';
import Mumbaitopunecab from './pages/Mumbai to Pune Cab';
import Mumbaitogoa from './pages/Mumbai to Goa Taxi';
import Mumbaiairportcab from './pages/Mumbai Airport Cab';
import Mumbaisuratcabs from './pages/Mumbai Surat Cabs';
import Mumbaitomahabaleshwer from './pages/Mumbai to Mahabaleshwar Cab';
import Mumbaitokonkan from './pages/Mumbai to Konkan Cab';
import Punecabservice from './pages/Pune Cab Service';
import Punetaxihire from './pages/Pune Taxi Hire';
import Puneonlinecabbooking from './pages/Pune Online Cab Booking';
import Bestcabservice from './pages/Best Cab Service in Pune';
import Punetomumbaicabs from './pages/Pune to Mumbai Cabs';
import Punetonashikcabs from './pages/Pune to Nasik Cabs';
import Punetomahabaleshwer from './pages/Pune to Mahabaleshwar Cabs';
import Punetolonavalacabs from './pages/Pune to Lonavala Cabs';
import Punetoshirdicabs from './pages/Pune to Shirdi Cab';
import Punetolavasacity from './pages/Pune to Lavasa city cabs';
import Punetobhimashankar from './pages/Pune to Bhimashankar Cab';
import Punetoindore from './pages/Pune to Indore Cabs';
import Punetokonkandarshan from './pages/Pune to Konkan Darshan Cabs';
import Puneoutstationcab from './pages/Pune Outstation Cabs';
import Punetopanchganicab from './pages/Pune to Panchgani Cab Fare';
import Punetomumbaiinternational from './pages/Pune to Mumbai International Airport Cab';
import Ashtavinayakdarshan from './pages/Ashtavinayak Darshan Cab';
import Punetonagpur from './pages/Pune to Nagpur Cabs';
import Punetogoacabs from './pages/Pune to Goa Cabs';
import Punetoajantaellora from './pages/Pune to Ajanta Ellora Cabs';
import Punetosataracabs from './pages/Pune to Satara Cabs';
import Puneairportcabs from './pages/Pune Airport Cabs';
import Cabservicesname from './pages/Cabs Services Near  Me';
import Corporatecabserviceinpune from './pages/Corporate Cab Service in Pune';
import Punetomumbaiairport from './pages/Pune to Mumbai Airport Cabs';
import Punetokohlapurcab from './pages/Pune to Kolhapur Cab';
import Tempotravellleronrent from './pages/Tempo Traveller On Rent in Pune';
import Punetopansharpurtaxi from './pages/Pune to Pandharpur Taxi';
import Urbaniaonrentinpune from './pages/Urbania On Rent in Pune';
import Innovacrystaonrentinpune from './pages/Innova Crysta On Rent in Pune';
import Volsawagenventoonrent from './pages/Volkswagen Vento On Rent';
import Swiftdzireonrentinpune from './pages/Swift Dzire On Rent In Pune';
import Tatazestonrentinpune from './pages/Tata Zest on Rent in Pune';
import Punetoimagicataxi from './pages/Pune to Imagica Taxi';
import Minibusonrentinpune from './pages/Mini Bus On Rent in Pune';
import Ertigaonrentinpune from './pages/Ertiga On Rent in Pune';
import Kiacarenceonrent from './pages/Kia Carens On Rent in Pune';
import Punetosambhajinagar from './pages/Pune to Sambhaji Nagar Taxi fare';
import Punetoganpatipule from './pages/Pune to Ganpatipule Taxi';
import PuneToHarihareshwarTaxi from './pages/Pune to Harihareshwar Taxi';
import Punetoalibag from './pages/Pune to Alibag Cabs';
import Punetopanvelcabs from './pages/Pune to Panvel Cabs';
import Punetohyderabad from './pages/Pune to Hyderabad Cabs';
import Punetobangloretaxi from './pages/Pune to Bangalore Taxi Service';
import Onewaycabpune from './pages/One Way Cab Pune';
import Taxiserviceinhadapdar from './pages/Taxi Service in Hadapsar';
import Taxiserviceinlohgaon from './pages/Taxi Service in Lohegaon';
import Cabserviceinvimannagar from './pages/Cab Service in Viman Nagar';
import Cabserviseinkhradi from './pages/Cab Service in Kharadi';
import Taxiserviceinhinjewadi from './pages/Taxi Service in Hinjewadi Pune';
import Punetogujrat from './pages/Pune to Gujarat Cab Service';
import Travelagentinpune from './pages/Travel Agents in Pune';
import Punetothanecabs from './pages/Pune to Thane Cab';
import Outstatationtaxiservice from './pages/Outstation Taxi Service Pune';
import Cabbookinginpune from './pages/Cab Booking in Pune';
import Onlinecabbookingpune from './pages/Online Cab Booking Pune';
import Explorepanindia from './pages/Explorer pan India cab service from Pune';
import Corporatecabservice from './pages/Corporate Cab Services in Pune';
import ScrollToTop from './component/ScrollToTop';
import ContactButtons from './component/ContactButtons';
import Mumbaitonashikcabs from './pages/Mumbai to Nasik Cabs';


function App() {
  return (
    <Router>
      <Header />
      <ScrollToTop/>
      <ContactButtons/>
      <Routes>
        <Route path="/" element={<HeroSection />} />
        <Route path="/about-us" element={<AboutSection />} />
        <Route path="/book-taxi" element={<Booking />} />
        <Route path="/our-fleet" element={<OurFleet/>} />
        <Route path="/gallery" element={<Gallery/>} />
        <Route path="/service" element={<Services/>} />
        <Route path="/our-network" element={<OurNetwork/>} />
        <Route path="/contact" element={<ContactSection/>} />
        <Route path="/enquiry" element={<Enquiry/>} />
        <Route path="/packages" element={<Packages/>} />
        <Route path="/carrer" element={<CareersSection/>} />
        <Route path="/term-condition" element={<TermsConditions/>} />
        <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
        <Route path="/blog" element={<Blog/>} />
        <Route path="/Mumbai-Cab-Service" element={<Mumbaicabservice/>} />
        <Route path="/Mumbai-to-Shirdi-Cab" element={<Mumbaitoshirdi/>} />
        <Route path="/Mumbai-Darshan-Cabs" element={<MumbaiDarshancabs/>} />
        <Route path="/Mumbai-to-Vadodara-Taxi" element={<Mumbaitovadodara/>} />
        <Route path="/Mumbai-to-Pune-Cab" element={<Mumbaitopunecab/>} />
        <Route path="/Mumbai-to-Goa-Taxi" element={<Mumbaitogoa/>} />
        <Route path="/Mumbai-Airport-Cab" element={<Mumbaiairportcab/>} />
        <Route path="/Mumbai-Surat-Cabs" element={<Mumbaisuratcabs/>} />
        <Route path="/Mumbai-to-Mahabaleshwar-Cab" element={<Mumbaitomahabaleshwer/>} />
        <Route path="/Mumbai-to-Konkan-Cab" element={<Mumbaitokonkan/>} />
        <Route path="/Pune-Cab-Service" element={<Punecabservice/>} />
        <Route path="/Pune-Taxi-Hire" element={<Punetaxihire/>} />
        <Route path="/Pune-Online-Cab-Booking" element={<Puneonlinecabbooking/>} />
        <Route path="/Best-Cab-Service-in-Pune" element={<Bestcabservice/>} />
        <Route path="/Pune-to-Mumbai-Cabs" element={<Punetomumbaicabs/>} />
        <Route path="/Pune-to-Nashik-Cabs" element={<Punetonashikcabs/>} />
        <Route path="/Pune-to-Mahabaleshwar-Cabs" element={<Punetomahabaleshwer/>} />
        <Route path="/Pune-to-Lonavala-Cabs" element={<Punetolonavalacabs/>} />
        <Route path="/Pune-to-Shirdi-Cab" element={<Punetoshirdicabs/>} />
        <Route path="/Pune-to-Lavasa-city-cabs" element={<Punetolavasacity/>} />
        <Route path="/Pune-to-Bhimashankar-Cab" element={<Punetobhimashankar/>} />
        <Route path="/Pune-to-Indore-Cabs" element={<Punetoindore/>} />
        <Route path="/Pune-to-Konkan-Darshan-Cabs" element={<Punetokonkandarshan/>} />
        <Route path="/Pune-Outstation-Cabs" element={<Puneoutstationcab/>} />
        <Route path="/Pune-to-Panchgani-Cab-Fare" element={<Punetopanchganicab/>} />
        <Route path="/Pune-to-Mumbai-International-Airport-Cab" element={<Punetomumbaiinternational/>} />
        <Route path="/Ashtavinayak-Darshan-Cab" element={<Ashtavinayakdarshan/>} />
        <Route path="/Pune-to-Nagpur-Cabs" element={<Punetonagpur/>} />
        <Route path="/Pune-to-Goa-Cabs" element={<Punetogoacabs/>} />
        <Route path="/Pune-to-Ajanta-Ellora-Cabs" element={<Punetoajantaellora/>} />
        <Route path="/Pune-to-Satara-Cabs" element={<Punetosataracabs/>} />
        <Route path="/Pune-Airport-Cabs" element={<Puneairportcabs/>} />
        <Route path="/Cabs-Services-Near-Me" element={<Cabservicesname/>} />
        <Route path="/Corporate-Cab-Service-in-Pune" element={<Corporatecabserviceinpune/>} />
        <Route path="/Pune-to-Mumbai-Airport-Cabs" element={<Punetomumbaiairport/>} />
        <Route path="/Pune-to-Kolhapur-Cab" element={<Punetokohlapurcab/>} />
        <Route path="/Tempo-Traveller-On-Rent-in-Pune" element={<Tempotravellleronrent/>} />
        <Route path="/Pune-to-Pandharpur-Taxi" element={<Punetopansharpurtaxi/>} />
        <Route path="/Urbania-On-Rent-in-Pune" element={<Urbaniaonrentinpune/>} />
        <Route path="/Innova-Cabs-on-Rent-in-Pune" element={<Innovacrystaonrentinpune/>} />
        <Route path="/Volkswagen-Vento-On-Rent" element={<Volsawagenventoonrent/>} />
        <Route path="/Swift-Dzire-On-Rent-In-Pune" element={<Swiftdzireonrentinpune/>} />
        <Route path="/Tata-Zest-on-Rent-in-Pune" element={<Tatazestonrentinpune/>} />
        <Route path="Pune-to-Imagica-Taxi" element={<Punetoimagicataxi/>} />
        <Route path="Mini-Bus-On-Rent-in-Pune" element={<Minibusonrentinpune/>} />
        <Route path="Ertiga-On-Rent-in-Pune" element={<Ertigaonrentinpune/>} />
        <Route path="Kia-Carens-On-Rent-in-Pune" element={<Kiacarenceonrent/>} />
        <Route path="Pune-to-Sambhaji-Nagar-Taxi-fare" element={<Punetosambhajinagar/>} />
        <Route path="Pune-to-Ganpatipule-Taxi" element={<Punetoganpatipule/>} />
        <Route path="Pune-to-Harihareshwar-Taxi" element={<PuneToHarihareshwarTaxi/>} />
        <Route path="Pune-to-Alibag-Cabs" element={<Punetoalibag/>} />
        <Route path="Pune-to-Panvel-Cabs" element={<Punetopanvelcabs/>} />
        <Route path="Pune-to-Hyderabad-Cabs" element={<Punetohyderabad/>} />
        <Route path="Pune-to-Bangalore-Taxi-Service" element={<Punetobangloretaxi/>} />
        <Route path="One-Way-Cab-Pune" element={<Onewaycabpune/>} />
        <Route path="Taxi-Service-in-Hadapsar" element={<Taxiserviceinhadapdar/>} />
        <Route path="Taxi-Service-in-Lohegaon" element={<Taxiserviceinlohgaon/>} />
        <Route path="Cab-Service-in-Viman-Nagar" element={<Cabserviceinvimannagar/>} />
        <Route path="Cab-Service-in-Kharadi" element={<Cabserviseinkhradi/>} />
        <Route path="Taxi-Service-in-Hinjewadi-Pune" element={<Taxiserviceinhinjewadi/>} />
        <Route path="Pune-to-Gujarat-Cab-Service" element={<Punetogujrat/>} />
        <Route path="Travel-Agents-in-Pune" element={<Travelagentinpune/>} />
        <Route path="Pune-to-Thane-Cab" element={<Punetothanecabs/>} />
        <Route path="Outstation-Taxi-Service-Pune" element={<Outstatationtaxiservice/>} />
        <Route path="Cab-Booking-in-Pune" element={<Cabbookinginpune/>} />
        <Route path="Online-Cab-Booking-Pune" element={<Onlinecabbookingpune/>} />
        <Route path="Explorer-pan-India-cab-service-from-Pune" element={<Explorepanindia/>} />
        <Route path="Corporate-Cab-Services-in-Pune" element={<Corporatecabservice/>} />
        <Route path="Mumbai-to-Nashik-Cab" element={<Mumbaitonashikcabs/>} />
      </Routes> 
    <Foot/>
    </Router>
  );
}

export default App;
